exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-comic-chapter-template-tsx": () => import("./../../../src/pages/comic-chapter-template.tsx" /* webpackChunkName: "component---src-pages-comic-chapter-template-tsx" */),
  "component---src-pages-comic-tsx": () => import("./../../../src/pages/comic.tsx" /* webpackChunkName: "component---src-pages-comic-tsx" */),
  "component---src-pages-gallery-tsx": () => import("./../../../src/pages/gallery.tsx" /* webpackChunkName: "component---src-pages-gallery-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

